import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import './AnalyticsDashboardRealTime.scss';

import {
  analyticsDashboard,
  fetchPeriodicAnalyticsDashboardContent
} from '../../../Apis/actions/analytics-dashboard-actions'; // need to un comment

import PropTypes from 'prop-types';

import AnalyticsRealTimeColumnsContainer from '../AnalyticsRealTimeColumnsContainer/AnalyticsRealTimeColumnsContainer';
// import AnalyticsRealTimeAccessColumnsContainer from '../AnalyticsRealTimeAccessColumnsContainer/AnalyticsRealTimeAccessColumnsContainer';

import classNames from 'classnames';

const AnalyticsDashboardRealTime = ({ setSection, subSection }) => {
  const dispatch = useDispatch();
  const { PeriodicCallRunning } = useSelector((state) => state.analyticsDashboardReducer);

  // const isUserSection = subSection === 'users';

  // const isEditorialSection = subSection === 'editorial';

  // const isMessengerSection = subSection === 'messenger';

  // const isTmxRequestsSection = subSection === 'tmx requests';

  // const isMessengerQueueSection = subSection === 'messenger queue';

  const isEmailPresent = JSON.parse(localStorage.getItem('userData'))?.email;
  const isTokenPresent = JSON.parse(localStorage.getItem('userData'))?.token;

  useEffect(() => {
    dispatch(
      analyticsDashboard({
        type: 'INITIAL',
        category: 'LIVE_USERS',
        email: isEmailPresent,
        token: isTokenPresent
      })
    ); // need to un comment
    dispatch(
      analyticsDashboard({
        type: 'INITIAL',
        category: 'LIVE_MESSAGES',
        email: isEmailPresent,
        token: isTokenPresent
      })
    ); // need to un comment
    dispatch(
      analyticsDashboard({
        type: 'INITIAL',
        category: 'LIVE_SIGNALS',
        email: isEmailPresent,
        token: isTokenPresent
      })
    ); // need to un comment

    // if (
    //   isUserSection ||
    //   isEditorialSection ||
    //   isMessengerSection ||
    //   isTmxRequestsSection ||
    //   isMessengerQueueSection
    // ) {
    // dispatch(analyticsDashboard({ type: 'INITIAL', category: 'ALL_NEWSROOM' })); // need to un comment
    // dispatch(analyticsDashboard({ type: 'INITIAL', category: 'CONTACTS' })); // need to un comment
    // } else {
    // dispatch(analyticsDashboard({ type: 'INITIAL', category: 'ALL_ACCESS' })); // need to un comment
    // }

    // const newsroomCollections = [
    //   'INVITES',
    //   'PITCHES',
    //   'CLEAREDARTICLES',
    //   'CLEARED',
    //   'ACTIVE_USERS',
    //   'NEW_USERS',
    //   'CONTACTS',
    //   'SOCIALSPOTTER',
    //   'TMX_MESSAGES_EXPERT',
    //   'TMX_MESSAGES_CLEARED',
    //   'TMX_MESSAGES_CONTACT',
    //   'TMX_MESSAGES_GENERAL',
    //   'NEWSROOM_ANALYTICS',
    //   'MESSENGER_QUEUE',
    //   'CUSTOM_ASSOCIATED_REPLIES'
    // ];

    // const accessCollections = [
    //   'INVITES_ACCESS',
    //   'NEW_JOURNALISTS',
    //   'ACTIVE_ACCESS_USERS',
    //   'REQUEST_REPLIES',
    //   'MESSAGES',
    //   'LIVE_PROFILES',
    //   'PROFILE_ACTIVITY'
    // ];

    // const collectionsToFetch =
    //   isUserSection ||
    //   isEditorialSection ||
    //   isMessengerSection ||
    //   isTmxRequestsSection ||
    //   isMessengerQueueSection
    //     ? [...commonCollection, ...newsroomCollections]
    //     : [...commonCollection, ...accessCollections];
  }, [dispatch, isEmailPresent, isTokenPresent]);

  useEffect(() => {
    const commonCollection = ['LIVE_USERS', 'LIVE_MESSAGES', 'LIVE_SIGNALS', 'LIVE_REPLIES'];

    const collectionsToFetch = [...commonCollection];

    if (!PeriodicCallRunning) {
      collectionsToFetch.forEach((category) => {
        dispatch(fetchPeriodicAnalyticsDashboardContent({ category })); // need to un comment
      });
    }
  }, [dispatch, PeriodicCallRunning]);

  return (
    <>
      <section className={classNames('tmx-analyticsDashboardRealTime__parentWrapper')}>
        {/* {(isUserSection ||
          isEditorialSection ||
          isMessengerSection ||
          isTmxRequestsSection ||
          isMessengerQueueSection) && ( */}
        <AnalyticsRealTimeColumnsContainer
          setSection={setSection}
          subSection={subSection}></AnalyticsRealTimeColumnsContainer>
        {/* )} */}
      </section>
    </>
  );
};

AnalyticsDashboardRealTime.propTypes = {
  setSection: PropTypes.func,
  subSection: PropTypes.string
};

export default AnalyticsDashboardRealTime;
